import { FETCH_RANGE_SEARCH } from "../actions/types";

export const rangeSearchReducer = (state = false, action) => {
  switch (action.type) {
    case FETCH_RANGE_SEARCH:
      return action.payload;
    default:
      return state;
  }
};
